(function() {
        const wines = [
          /* BOLLE */
          {
            attivo: true,
            colore: "bolle",
            paese: "IT",
            regione: "Emilia-Romagna",
            nome_vino: "Perfranco 2023",
            vigneron: "Gianluca Bergianti",
            cantina: "Terrevive (Bergianti)",
            uvaggio: "Lambrusco Salamino di Santa Croce",
            prezzo: 25
          },
          {
            attivo: true,
            colore: "bolle",
            paese: "IT",
            regione: "Emilia-Romagna",
            nome_vino: "Saint Vincent 2023",
            vigneron: "Gianluca Bergianti",
            cantina: "Terrevive (Bergianti)",
            uvaggio: "Lambrusco Grasparossa",
            prezzo: 25
          },
          {
            attivo: true,
            colore: "bolle",
            paese: "FR",
            regione: "Champagne",
            nome_vino: "Polisy Réserve",
            vigneron: "Jacques Beaufort",
            cantina: "André Beaufort",
            uvaggio: "Pinot Noir / Chardonnay",
            prezzo: 84
          },
          {
            attivo: true,
            colore: "bolle",
            paese: "FR",
            regione: "Champagne",
            nome_vino: "Polisy Rosé",
            vigneron: "Jacques Beaufort",
            cantina: "André Beaufort",
            uvaggio: "Pinot Noir",
            prezzo: 90
          },
          {
            attivo: true,
            colore: "bolle",
            paese: "FR",
            regione: "Champagne",
            nome_vino: "Ambonnay Non Dosé",
            vigneron: "Jacques Beaufort",
            cantina: "André Beaufort",
            uvaggio: "Pinot Noir / Chardonnay",
            prezzo: 110
          },
          {
            attivo: true,
            colore: "bolle",
            paese: "FR",
            regione: "Champagne",
            nome_vino: "Ambonnay Grand Cru Rosé",
            vigneron: "Jacques Beaufort",
            cantina: "André Beaufort",
            uvaggio: "Pinot Noir",
            prezzo: 116
          },
          {
            attivo: true,
            colore: "bolle",
            paese: "FR",
            regione: "Borgogna",
            nome_vino: "Crémant “Assemblage”",
            vigneron: "Constance & Valentin",
            cantina: "Constance & Valentin",
            uvaggio: "Pinot Noir / Chardonnay",
            prezzo: 35
          },
          {
            attivo: true,
            colore: "bolle",
            paese: "FR",
            regione: "Jura",
            nome_vino: "Crémant Brut Non Dosé 2022",
            vigneron: "Champ Divin",
            cantina: "Champ Divin",
            uvaggio: "Chardonnay / Savagnin",
            prezzo: 35
          },
          {
            attivo: true,
            colore: "bolle",
            paese: "IT",
            regione: "Veneto",
            nome_vino: "Epochè VSQ Dosaggio Zero Metodo Classico 2022",
            vigneron: "Muni",
            cantina: "Muni",
            uvaggio: "Durella",
            prezzo: 35
          },
          {
            attivo: true,
            colore: "bolle",
            paese: "IT",
            regione: "Lombardia",
            nome_vino: "Nature",
            vigneron: "Chiara Torti",
            cantina: "Chiara Torti",
            uvaggio: "Pinot Nero",
            prezzo: 25
          },
          {
            attivo: true,
            colore: "bolle",
            paese: "OTHER",
            regione: "Portogallo",
            nome_vino: "3B Blanc de Blancs",
            vigneron: "Filipa Pato",
            cantina: "Filipa Pato",
            uvaggio: "Baga / Bical",
            prezzo: 32
          },

          /* BIANCHI */
          {
            attivo: true,
            colore: "bianchi",
            paese: "IT",
            regione: "Piemonte",
            nome_vino: "Ivag 2023",
            vigneron: "Eredi Bellotti",
            cantina: "Cascina degli Ulivi",
            uvaggio: "Cortese",
            prezzo: 35
          },
          {
            attivo: true,
            colore: "bianchi",
            paese: "FR",
            regione: "Borgogna",
            nome_vino: "Bourgogne Chardonnay 2023",
            vigneron: "Château de Béru",
            cantina: "Béru",
            uvaggio: "Chardonnay",
            prezzo: 52
          },
          {
            attivo: true,
            colore: "bianchi",
            paese: "FR",
            regione: "Borgogna",
            nome_vino: "Beaune Blanc 2015",
            vigneron: "Jean-Pascal Sarnin & Guillaume Berrux",
            cantina: "Sarnin-Berrux",
            uvaggio: "Chardonnay",
            prezzo: 78
          },
          {
            attivo: true,
            colore: "bianchi",
            paese: "FR",
            regione: "Borgogna",
            nome_vino: "Bourgogne Blanc 2023",
            vigneron: "Marc Soyard",
            cantina: "Domaine de la Cras",
            uvaggio: "Chardonnay",
            prezzo: 55
          },
          {
            attivo: true,
            colore: "bianchi",
            paese: "FR",
            regione: "Borgogna",
            nome_vino: "Bourgogne “Cras” Blanc 2023",
            vigneron: "Marc Soyard",
            cantina: "Domaine de la Cras",
            uvaggio: "Chardonnay",
            prezzo: 85
          },
          {
            attivo: true,
            colore: "bianchi",
            paese: "FR",
            regione: "Borgogna",
            nome_vino: "Chablis “Côte aux Prêtres” 2022",
            vigneron: "Château de Béru",
            cantina: "Béru",
            uvaggio: "Chardonnay",
            prezzo: 80
          },
          {
            attivo: true,
            colore: "bianchi",
            paese: "FR",
            regione: "Borgogna",
            nome_vino: "Chablis “Terroirs de Béru” 2023",
            vigneron: "Château de Béru",
            cantina: "Béru",
            uvaggio: "Chardonnay",
            prezzo: 60
          },
          {
            attivo: true,
            colore: "bianchi",
            paese: "FR",
            regione: "Borgogna",
            nome_vino: "L’Équilibriste Blanc Magnum 2023",
            vigneron: "Marc Soyard",
            cantina: "Domaine de la Cras",
            uvaggio: "Chardonnay (Magnum)",
            prezzo: 170
          },
          {
            attivo: true,
            colore: "bianchi",
            paese: "FR",
            regione: "Borgogna",
            nome_vino: "Aligoté Classique 2023",
            vigneron: "Sylvain Pataille",
            cantina: "Domaine Sylvain Pataille",
            uvaggio: "Aligoté",
            prezzo: 36
          },
          {
            attivo: true,
            colore: "bianchi",
            paese: "FR",
            regione: "Borgogna",
            nome_vino: "Vézelay “Le Clos Dû” Chardonnay 2023",
            vigneron: "Hélène & Olivier Varenne",
            cantina: "Domaine La Mutine",
            uvaggio: "Chardonnay",
            prezzo: 49
          },
          {
            attivo: true,
            colore: "bianchi",
            paese: "FR",
            regione: "Jura",
            nome_vino: "Chardonnay “Champs Poids” 2021",
            vigneron: "Anne & Jean-François Ganevat",
            cantina: "Anne & Jean-François Ganevat",
            uvaggio: "Chardonnay",
            prezzo: 90
          },
          {
            attivo: true,
            colore: "bianchi",
            paese: "FR",
            regione: "Jura",
            nome_vino: "Chardonnay “Les Survivants” 2021",
            vigneron: "Domaine Ganevat",
            cantina: "Domaine Ganevat",
            uvaggio: "Chardonnay",
            prezzo: 150
          },
          {
            attivo: true,
            colore: "bianchi",
            paese: "FR",
            regione: "Jura",
            nome_vino: "Savagnin Sous la Roche 2019",
            vigneron: "Jean-François Ganevat",
            cantina: "Domaine Ganevat",
            uvaggio: "Savagnin",
            prezzo: 230
          },
          {
            attivo: true,
            colore: "bianchi",
            paese: "FR",
            regione: "Jura",
            nome_vino: "Traminer Longefin 2022",
            vigneron: "Renaud Bruyère & Adeline Houillon",
            cantina: "Domaine Grappe",
            uvaggio: "Savagnin",
            prezzo: 52
          },
          {
            attivo: true,
            colore: "bianchi",
            paese: "FR",
            regione: "Loira",
            nome_vino: "Classic 2023",
            vigneron: "Fred Niger",
            cantina: "Vignoble de l’Ecu",
            uvaggio: "Melon de Bourgogne",
            prezzo: 28
          },
          {
            attivo: true,
            colore: "bianchi",
            paese: "FR",
            regione: "Loira",
            nome_vino: "Marguerite 2023",
            vigneron: "Fred Niger",
            cantina: "Vignoble de l’Ecu",
            uvaggio: "Folle Blanche",
            prezzo: 32
          },
          {
            attivo: true,
            colore: "bianchi",
            paese: "FR",
            regione: "Loira",
            nome_vino: "Folle Blanche 2024",
            vigneron: "Antoine Delaunay",
            cantina: "Antoine Delaunay",
            uvaggio: "Folle Blanche",
            prezzo: 28
          },
          {
            attivo: true,
            colore: "bianchi",
            paese: "FR",
            regione: "Loira",
            nome_vino: "Opera Blanc 2021",
            vigneron: "Jean-Pierre Robinot",
            cantina: "Domaine de l’Ange Vin",
            uvaggio: "Chenin Blanc",
            prezzo: 58
          },
          {
            attivo: true,
            colore: "bianchi",
            paese: "FR",
            regione: "Roussillon",
            nome_vino: "Matassa Blanc 2023",
            vigneron: "Tom Lubbe",
            cantina: "Domaine Matassa",
            uvaggio: "Macabeu / Grenache Blanc",
            prezzo: 53
          },
          {
            attivo: true,
            colore: "bianchi",
            paese: "IT",
            regione: "Sicilia",
            nome_vino: "Solfare 2024",
            vigneron: "Giuseppe Cipolla",
            cantina: "Azienda Agricola Giuseppe Cipolla",
            uvaggio: "Catarratto / Zibibbo",
            prezzo: 40
          },
          {
            attivo: true,
            colore: "bianchi",
            paese: "IT",
            regione: "Abruzzo",
            nome_vino: "Il Postino",
            vigneron: "Colle Florido",
            cantina: "Colle Florido",
            uvaggio: "Trebbiano (Abruzzo)",
            prezzo: 35
          },
          {
            attivo: true,
            colore: "bianchi",
            paese: "OTHER",
            regione: "Occitania",
            nome_vino: "Marìn 2023",
            vigneron: "Mare Nostrum",
            cantina: "Mare Nostrum",
            uvaggio: "Piquepoul blanc, barriques usate",
            prezzo: 42
          },
          {
            attivo: true,
            colore: "bianchi",
            paese: "IT",
            regione: "Oltrepò Pavese",
            nome_vino: "Gwyn 2022",
            vigneron: "Augusto Andi",
            cantina: "Augusto Andi",
            uvaggio: "Varietà Georgiane",
            prezzo: 25
          },
          {
            attivo: true,
            colore: "bianchi",
            paese: "IT",
            regione: "Emilia",
            nome_vino: "Vertù 2023",
            vigneron: "Lusenti",
            cantina: "Lusenti",
            uvaggio: "Malvasia / Chardonnay / Ortrugo",
            prezzo: 25
          },

          /* ORANGE */
          {
            attivo: true,
            colore: "orange",
            paese: "IT",
            regione: "Emilia-Romagna",
            nome_vino: "Ageno 2020",
            vigneron: "Elena Pantaleoni",
            cantina: "La Stoppa",
            uvaggio: "Malvasia di Candia Aromatica / Ortrugo / Trebbiano",
            prezzo: 39
          },
          {
            attivo: true,
            colore: "orange",
            paese: "FR",
            regione: "Roussillon",
            nome_vino: "Blossom 2024",
            vigneron: "Tom Lubbe",
            cantina: "Domaine Matassa",
            uvaggio: "blend di uve autoctone",
            prezzo: 55
          },
          {
            attivo: true,
            colore: "orange",
            paese: "IT",
            regione: "Bergamo",
            nome_vino: "Tilamòre 2024",
            vigneron: "Le Driadi",
            cantina: "Le Driadi",
            uvaggio: "Bronner / Moscato giallo",
            prezzo: 32
          },
          {
            attivo: true,
            colore: "orange",
            paese: "IT",
            regione: "Emilia-Romagna",
            nome_vino: "Statale 412",
            vigneron: "Filarole",
            cantina: "Azienda Agricola Filarole",
            uvaggio: "Ortrugo 50% / Verdea 40% / Malvasia di Candia aromatica",
            prezzo: 25
          },

          /* ROSATI */
          {
            attivo: true,
            colore: "rosati",
            paese: "IT",
            regione: "Sicilia",
            nome_vino: "Occhio di Sale 2024",
            vigneron: "Giuseppe Cipolla",
            cantina: "Azienda Agricola Giuseppe Cipolla",
            uvaggio: "Nero d'Avola / Catarratto / Nerello Mascalese / altre uve autoctone",
            prezzo: 32
          },
          {
            attivo: true,
            colore: "rosati",
            paese: "IT",
            regione: "Abruzzo",
            nome_vino: "LaLèna 2024",
            vigneron: "Colle Florido",
            cantina: "Colle Florido",
            uvaggio: "Montepulciano",
            prezzo: 35
          },

          /* ROSSI */
          {
            attivo: true,
            colore: "rossi",
            paese: "IT",
            regione: "Sicilia",
            nome_vino: "Munjebel Rosso 2022",
            vigneron: "Frank Cornelissen",
            cantina: "Az. Agr. Frank Cornelissen",
            uvaggio: "Nerello Mascalese",
            prezzo: 51
          },
          {
            attivo: true,
            colore: "rossi",
            paese: "IT",
            regione: "Sicilia",
            nome_vino: "Munjebel CR Campo Re 2020",
            vigneron: "Frank Cornelissen",
            cantina: "Az. Agr. Frank Cornelissen",
            uvaggio: "Nerello Mascalese",
            prezzo: 111
          },
          {
            attivo: true,
            colore: "rossi",
            paese: "IT",
            regione: "Sicilia",
            nome_vino: "Munjebel VA Vigne Alte 2020",
            vigneron: "Frank Cornelissen",
            cantina: "Az. Agr. Frank Cornelissen",
            uvaggio: "Nerello Mascalese",
            prezzo: 147
          },
          {
            attivo: true,
            colore: "rossi",
            paese: "IT",
            regione: "Sicilia",
            nome_vino: "Susucaru Rosso 2022",
            vigneron: "Frank Cornelissen",
            cantina: "Az. Agr. Frank Cornelissen",
            uvaggio: "blend di uve autoctone",
            prezzo: 34
          },
          {
            attivo: true,
            colore: "rossi",
            paese: "IT",
            regione: "Toscana",
            nome_vino: "Sogni e Follia 2021",
            vigneron: "Francesco Illy",
            cantina: "Podere Le Ripi",
            uvaggio: "Sangiovese",
            prezzo: 35
          },
          {
            attivo: true,
            colore: "rossi",
            paese: "IT",
            regione: "Toscana",
            nome_vino: "Brunello di Montalcino “Amore e Magia”",
            vigneron: "Francesco Illy",
            cantina: "Podere Le Ripi",
            uvaggio: "Sangiovese",
            prezzo: 85
          },
          {
            attivo: true,
            colore: "rossi",
            paese: "IT",
            regione: "Piemonte",
            nome_vino: "L’Informale 2024",
            vigneron: "Nadia Curto",
            cantina: "Az. Agr. Nadia Curto",
            uvaggio: "Nebbiolo / Barbera",
            prezzo: 28
          },
          {
            attivo: true,
            colore: "rossi",
            paese: "IT",
            regione: "Piemonte",
            nome_vino: "Barbera d’Alba 2022",
            vigneron: "Nadia Curto",
            cantina: "Az. Agr. Nadia Curto",
            uvaggio: "Barbera",
            prezzo: 29
          },
          {
            attivo: true,
            colore: "rossi",
            paese: "FR",
            regione: "Beaujolais",
            nome_vino: "Morgon 2023",
            vigneron: "Jean Foillard",
            cantina: "Domaine Jean Foillard",
            uvaggio: "Gamay",
            prezzo: 32
          },
          {
            attivo: true,
            colore: "rossi",
            paese: "FR",
            regione: "Beaujolais",
            nome_vino: "Morgon 2024",
            vigneron: "Camille & Mathieu Lapierre",
            cantina: "Domaine Marcel Lapierre",
            uvaggio: "Gamay",
            prezzo: 43
          },
          {
            attivo: true,
            colore: "rossi",
            paese: "FR",
            regione: "Borgogna",
            nome_vino: "Beaune 1er Cru “Les Reversées” 2023",
            vigneron: "Jean-Claude Rateau",
            cantina: "Domaine Jean-Claude Rateau",
            uvaggio: "Pinot Noir",
            prezzo: 78
          },
          {
            attivo: true,
            colore: "rossi",
            paese: "FR",
            regione: "Borgogna",
            nome_vino: "Côte-de-Nuits Villages “Les Vaucrains” 2022",
            vigneron: "Antoine Petitprez",
            cantina: "Domaine ULIZ",
            uvaggio: "Pinot Noir",
            prezzo: 85
          },
          {
            attivo: true,
            colore: "rossi",
            paese: "FR",
            regione: "Borgogna",
            nome_vino: "Bourgogne Rouge 2023",
            vigneron: "Marc Soyard",
            cantina: "Domaine de la Cras",
            uvaggio: "Pinot Noir",
            prezzo: 55
          },
          {
            attivo: true,
            colore: "rossi",
            paese: "FR",
            regione: "Borgogna",
            nome_vino: "Bourgogne “Cras” Rouge 2023",
            vigneron: "Marc Soyard",
            cantina: "Domaine de la Cras",
            uvaggio: "Pinot Noir",
            prezzo: 85
          },
          {
            attivo: true,
            colore: "rossi",
            paese: "FR",
            regione: "Borgogna",
            nome_vino: "L’Équilibriste Rouge 2023",
            vigneron: "Marc Soyard",
            cantina: "Domaine de la Cras",
            uvaggio: "Pinot Noir",
            prezzo: 82
          },
          {
            attivo: true,
            colore: "rossi",
            paese: "FR",
            regione: "Borgogna",
            nome_vino: "Hermaïon 2023",
            vigneron: "Marc Soyard",
            cantina: "Domaine de la Cras",
            uvaggio: "Pinot Noir / Gamay",
            prezzo: 220
          },
          {
            attivo: true,
            colore: "rossi",
            paese: "FR",
            regione: "Borgogna",
            nome_vino: "Déprimeur 2025",
            vigneron: "Marc Soyard",
            cantina: "Domaine de la Cras",
            uvaggio: "blend di uve autoctone",
            prezzo: 55
          },
          {
            attivo: true,
            colore: "rossi",
            paese: "FR",
            regione: "Loira",
            nome_vino: "Opera Rouge 2021",
            vigneron: "Jean-Pierre Robinot",
            cantina: "Domaine de l’Ange Vin",
            uvaggio: "Pineau d’Aunis",
            prezzo: 58
          },
          {
            attivo: true,
            colore: "rossi",
            paese: "FR",
            regione: "Rodano",
            nome_vino: "Syrah 2024",
            vigneron: "Jean-Michel Stéphan",
            cantina: "Maison Stéphan",
            uvaggio: "Syrah",
            prezzo: 45
          },
          {
            attivo: true,
            colore: "rossi",
            paese: "FR",
            regione: "Roussillon",
            nome_vino: "Matassa Rouge 2023",
            vigneron: "Tom Lubbe",
            cantina: "Domaine Matassa",
            uvaggio: "Carignan / Grenache Noir",
            prezzo: 53
          },
          {
            attivo: true,
            colore: "rossi",
            paese: "OTHER",
            regione: "Austria",
            nome_vino: "Puszta Libre 2024",
            vigneron: "Claus Preisinger",
            cantina: "Weingut Claus Preisinger",
            uvaggio: "Zweigelt / Saint Laurent",
            prezzo: 25
          },
          {
            attivo: true,
            colore: "rossi",
            paese: "IT",
            regione: "Veneto",
            nome_vino: "Valpolicella Classico “Saseti” 2024",
            vigneron: "Monte Dall’Ora",
            cantina: "Monte Dall’Ora",
            uvaggio: "Corvina / Corvinone / Rondinella",
            prezzo: 25
          },
          {
            attivo: true,
            colore: "rossi",
            paese: "IT",
            regione: "Veneto",
            nome_vino: "Valpolicella Ripasso Classico “Saustò” 2023",
            vigneron: "Monte Dall’Ora",
            cantina: "Monte Dall’Ora",
            uvaggio: "Corvina / Corvinone / Rondinella",
            prezzo: 35
          },
          {
            attivo: true,
            colore: "rossi",
            paese: "FR",
            regione: "Rodano",
            nome_vino: "Brézème Vieille Sérine 2018",
            vigneron: "Eric Texier",
            cantina: "Eric Texier",
            uvaggio: "Syrah (Serine)",
            prezzo: 50
          },
          {
            attivo: true,
            colore: "rossi",
            paese: "FR",
            regione: "Rodano",
            nome_vino: "Brézème Vieille Sérine 2019",
            vigneron: "Eric Texier",
            cantina: "Eric Texier",
            uvaggio: "Syrah (Serine)",
            prezzo: 50
          },
          {
            attivo: true,
            colore: "rossi",
            paese: "IT",
            regione: "Abruzzo",
            nome_vino: "Salvo",
            vigneron: "Colle Florido",
            cantina: "Colle Florido",
            uvaggio: "Montepulciano",
            prezzo: 25
          },
          {
            attivo: true,
            colore: "rossi",
            paese: "OTHER",
            regione: "Spagna",
            nome_vino: "Tramuntana Rosso 2021",
            vigneron: "Mare Nostrum",
            cantina: "Mare Nostrum",
            uvaggio: "Grenache / Carignan",
            prezzo: 42
          },
          {
            attivo: true,
            colore: "rossi",
            paese: "IT",
            regione: "Bergamo",
            nome_vino: "Contronoia 2024",
            vigneron: "Le Driadi",
            cantina: "Le Driadi",
            uvaggio: "Incrocio Terzi",
            prezzo: 25
          },
          {
            attivo: true,
            colore: "rossi",
            paese: "IT",
            regione: "Bergamo",
            nome_vino: "Driade Felice 2024",
            vigneron: "Le Driadi",
            cantina: "Le Driadi",
            uvaggio: "Merlot",
            prezzo: 25
          },
          {
            attivo: true,
            colore: "rossi",
            paese: "IT",
            regione: "Oltrepò Pavese",
            nome_vino: "Tom 2020",
            vigneron: "Augusto Andi",
            cantina: "Augusto Andi",
            uvaggio: "Croatina / Barbera",
            prezzo: 25
          },
          {
            attivo: true,
            colore: "rossi",
            paese: "IT",
            regione: "Emilia",
            nome_vino: "Ciaomare 2023",
            vigneron: "Lusenti",
            cantina: "Lusenti",
            uvaggio: "Barbera",
            prezzo: 25
          },
          {
            attivo: true,
            colore: "rossi",
            paese: "IT",
            regione: "Piemonte",
            nome_vino: "Nebbiolo",
            vigneron: "Cristina Prandi",
            cantina: "Cristina Prandi",
            uvaggio: "Nebbiolo",
            prezzo: 45
          },
          {
            attivo: true,
            colore: "rossi",
            paese: "IT",
            regione: "Toscana",
            nome_vino: "Rosso di Montalcino 2023",
            vigneron: "John Benda",
            cantina: "John Benda",
            uvaggio: "Sangiovese",
            prezzo: 70
          },
          {
            attivo: true,
            colore: "rossi",
            paese: "IT",
            regione: "Toscana",
            nome_vino: "Rosso di Montalcino 2024",
            vigneron: "Marino Colleoni",
            cantina: "Marino Colleoni",
            uvaggio: "Sangiovese",
            prezzo: 65
          },
          {
            attivo: true,
            colore: "rossi",
            paese: "FR",
            regione: "Jura",
            nome_vino: "Les Chonchons 2024",
            vigneron: "Anne & Jean-François Ganevat",
            cantina: "Anne & Jean-François Ganevat",
            uvaggio: "Pinot nero",
            prezzo: 80
          }
        ];

        const categoryOrder = ["bolle", "bianchi", "orange", "rosati", "rossi"];
        const categoryMeta = {
          bolle: { label: "Bolle", subtitle: "Metodo classico, rifermentati, Champagne" },
          bianchi: { label: "Bianchi", subtitle: "Vini bianchi fermi" },
          orange: { label: "Orange", subtitle: "Vini macerati" },
          rosati: { label: "Rosati", subtitle: "Rosati e light red" },
          rossi: { label: "Rossi", subtitle: "Vini rossi fermi" }
        };

        const countryLabels = {
          IT: "Italia",
          FR: "Francia",
          OTHER: "Altri Paesi"
        };

        let activeCategory = "all";
        let activeCountry = "all";

        var heroBtn = document.getElementById('cw-hero-button');
        var heroSection = document.getElementById('cw-hero');
        var wineListSection = document.getElementById('cavallo-wine-list');

        var specialBtn = document.getElementById('cw-hero-special-button');
        var menuBtn = document.getElementById('cw-hero-menu-button');
        var eventiBtn = document.getElementById('cw-hero-eventi-button');
        var pranzoBtnMobile = document.getElementById('cw-hero-pranzo-button');
        var seraBtnMobile = document.getElementById('cw-hero-sera-button');

        var menuOverlay = document.getElementById('cw-menu-overlay');
        var menuCloseBtn = document.getElementById('cw-menu-close');
        var menuOverlayImage = document.getElementById('cw-menu-overlay-image');

        var linkMenu = document.getElementById('cw-link-menu');
        var linkPranzo = document.getElementById('cw-link-pranzo');
        var linkSera = document.getElementById('cw-link-sera');
        var desktopMenuSubmenu = document.getElementById('cw-desktop-menu-submenu');

        var linkCarta = document.getElementById('cw-link-carta');
        var linkContatti = document.getElementById('cw-link-contatti');
        var linkEventi = document.getElementById('cw-link-eventi');

        function openCartaVini() {
          if (heroSection && wineListSection) {
            heroSection.style.display = 'none';
            wineListSection.style.display = 'block';
            window.scrollTo({ top: 0, behavior: 'smooth' });
          }
        }

        function toggleDesktopMenuSubmenu() {
          if (desktopMenuSubmenu) {
            desktopMenuSubmenu.classList.toggle('cw-open');
          }
        }

        function toggleMobileMenuSubmenu() {
          if (pranzoBtnMobile) pranzoBtnMobile.classList.toggle('cw-open');
          if (seraBtnMobile) seraBtnMobile.classList.toggle('cw-open');
        }

        function closeMobileMenuSubmenu() {
          if (pranzoBtnMobile) pranzoBtnMobile.classList.remove('cw-open');
          if (seraBtnMobile) seraBtnMobile.classList.remove('cw-open');
        }

        function openMenuImage(imageSrc, imageAlt) {
          if (menuOverlay && menuOverlayImage) {
            menuOverlayImage.src = imageSrc;
            menuOverlayImage.alt = imageAlt;
            menuOverlay.classList.add('cw-open');
          }
        }

        function openPranzoMenu() {
          openMenuImage(window.cwPranzoImg, "Menu Pranzo Chiosco Cavallo");
          closeMobileMenuSubmenu();
        }

        function openSeraMenu() {
          openMenuImage(window.cwCenaImg, "Menu Sera Chiosco Cavallo");
          closeMobileMenuSubmenu();
        }

        function openContatti() {
          window.location.href = 'mailto:info@cavalloselection.it?subject=Richiesta%20informazioni&body=Scrivici%20le%20tue%20richieste%20(per%20vini,%20bottiglie%20grandi,%20eventi,%20ecc.)';
        }

        function openEventi() {
          window.location.href = 'https://www.eventbrite.it/o/chiosco-cavallo-116148440371';
        }

        if (heroBtn) heroBtn.addEventListener('click', openCartaVini);
        if (linkCarta) linkCarta.addEventListener('click', openCartaVini);

        if (menuBtn) menuBtn.addEventListener('click', toggleMobileMenuSubmenu);
        if (linkMenu) linkMenu.addEventListener('click', toggleDesktopMenuSubmenu);

        if (pranzoBtnMobile) pranzoBtnMobile.addEventListener('click', openPranzoMenu);
        if (seraBtnMobile) seraBtnMobile.addEventListener('click', openSeraMenu);
        if (linkPranzo) linkPranzo.addEventListener('click', openPranzoMenu);
        if (linkSera) linkSera.addEventListener('click', openSeraMenu);

        if (specialBtn) specialBtn.addEventListener('click', openContatti);
        if (linkContatti) linkContatti.addEventListener('click', openContatti);

        if (eventiBtn) eventiBtn.addEventListener('click', openEventi);
        if (linkEventi) linkEventi.addEventListener('click', openEventi);

        if (menuCloseBtn && menuOverlay) {
          menuCloseBtn.addEventListener('click', function() {
            menuOverlay.classList.remove('cw-open');
          });
        }

        if (menuOverlay) {
          menuOverlay.addEventListener('click', function(e) {
            if (e.target === menuOverlay) {
              menuOverlay.classList.remove('cw-open');
            }
          });
        }

        const root = document.getElementById('cw-categories-root');
        const categoryButtons = document.querySelectorAll('[data-filter-category]');
        const countryButtons = document.querySelectorAll('[data-filter-country]');

        function renderWines() {
          if (!root) return;
          root.innerHTML = "";

          const filtered = wines.filter(w =>
            w.attivo &&
            (activeCategory === "all" || w.colore === activeCategory) &&
            (activeCountry === "all" || w.paese === activeCountry)
          );

          if (filtered.length === 0) {
            root.innerHTML = '<p class="cw-empty">Nessun vino disponibile per i filtri selezionati.</p>';
            return;
          }

          const byCategory = {};
          filtered.forEach(w => {
            if (!byCategory[w.colore]) byCategory[w.colore] = [];
            byCategory[w.colore].push(w);
          });

          categoryOrder.forEach(catKey => {
            const winesInCat = byCategory[catKey];
            if (!winesInCat || winesInCat.length === 0) return;

            const meta = categoryMeta[catKey];
            const section = document.createElement("section");
            section.className = "cw-sezione-categoria";

            const h2 = document.createElement("h2");
            h2.className = "cw-categoria-titolo";
            h2.textContent = meta ? meta.label : catKey;
            if (meta && meta.subtitle) {
              const span = document.createElement("span");
              span.textContent = meta.subtitle;
              h2.appendChild(span);
            }
            section.appendChild(h2);

            const byRegionKey = {};
            winesInCat.forEach(w => {
              const key = w.paese + "|" + w.regione;
              if (!byRegionKey[key]) byRegionKey[key] = [];
              byRegionKey[key].push(w);
            });

            Object.keys(byRegionKey)
              .sort()
              .forEach(key => {
                const [paese, regione] = key.split("|");
                const regioneBlock = document.createElement("div");
                regioneBlock.className = "cw-regione-blocco";

                const header = document.createElement("div");
                header.className = "cw-regione-intestazione";
                header.textContent = (countryLabels[paese] || paese) + " — " + regione;
                regioneBlock.appendChild(header);

                const list = document.createElement("div");
                list.className = "cw-wine-list";

                byRegionKey[key]
                  .sort((a, b) => a.nome_vino.localeCompare(b.nome_vino, 'it'))
                  .forEach(w => {
                    const item = document.createElement("div");
                    item.className = "cw-wine-item";

                    const main = document.createElement("div");
                    main.className = "cw-wine-main";

                    const headerRow = document.createElement("div");
                    headerRow.className = "cw-wine-header";

                    const nameSpan = document.createElement("span");
                    nameSpan.className = "cw-wine-name";
                    nameSpan.textContent = w.nome_vino;
                    headerRow.appendChild(nameSpan);

                    if (w.prezzo !== null && w.prezzo !== undefined) {
                      const priceSpan = document.createElement("span");
                      priceSpan.className = "cw-wine-price";
                      priceSpan.textContent = w.prezzo + " €";
                      headerRow.appendChild(priceSpan);
                    }

                    main.appendChild(headerRow);

                    const metaLine = document.createElement("div");
                    metaLine.className = "cw-wine-meta";
                    metaLine.textContent = w.vigneron + " · " + w.cantina;
                    main.appendChild(metaLine);

                    const grapesLine = document.createElement("div");
                    grapesLine.className = "cw-wine-grapes";
                    grapesLine.textContent = w.uvaggio;
                    main.appendChild(grapesLine);

                    item.appendChild(main);
                    list.appendChild(item);
                  });

                regioneBlock.appendChild(list);
                section.appendChild(regioneBlock);
              });

            root.appendChild(section);
          });
        }

        categoryButtons.forEach(btn => {
          btn.addEventListener('click', () => {
            categoryButtons.forEach(b => b.classList.remove('cw-active'));
            btn.classList.add('cw-active');
            activeCategory = btn.getAttribute('data-filter-category');
            renderWines();
          });
        });

        countryButtons.forEach(btn => {
          btn.addEventListener('click', () => {
            countryButtons.forEach(b => b.classList.remove('cw-active'));
            btn.classList.add('cw-active');
            activeCountry = btn.getAttribute('data-filter-country');
            renderWines();
          });
        });

        renderWines();
      })();
